<template>
  <div class="app-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters" size="mini" label-width="60px">
        <el-form-item label="部门" prop="deptId">
          <popup-tree-input
            :data="deptData"
            :props="deptTreeProps"
            :prop="filters.name"
            :node-key="'' + filters.deptId"
            :current-change-handle="deptTreeCurrentChangeHandles"
            class="treescol"
          />
        </el-form-item>
        <el-form-item label="考勤组" prop="managementId">
          <el-select
            style="width: 100%"
            filterable
            clearable
            v-model="filters.managementId"
            placeholder="请选择考勤组"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <el-button icon="fa fa-search" type="primary" @click="handleFilter(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="title">考勤数据</div>
    <el-row style="margin-bottom: 10px" :gutter="30">
      <el-col :xs="8" :sm="6" :md="4" :lg="{ span: '24-5' }">
        <div class="line" @click="getType('1')">
          <div class="des">
            应到人数
          </div>
          <div class="title number">
            {{ count.shouldArriveCount }}
          </div>
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="4" :lg="{ span: '24-5' }">
        <div class="line" @click="getType('2')">
          <div class="des">
            打卡人数
          </div>
          <div class="title number">
            {{ count.clockInPersonnelCount }}
          </div>
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="4" :lg="{ span: '24-5' }">
        <div class="line" @click="getType('3')">
          <div class="des">
            未打卡人数
          </div>
          <div class="title number">
            {{ count.notClockInPersonnelCount }}
          </div>
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="4" :lg="{ span: '24-5' }">
        <div class="line" @click="getType('4')">
          <div class="des">
            迟到人数
          </div>
          <div class="title number">
            {{ count.beLateCount }}
          </div>
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="4" :lg="{ span: '24-5' }">
        <div class="line" @click="getType('5')">
          <div class="des">
            早退人数
          </div>
          <div class="title number">
            {{ count.earlyLeaveCount }}
          </div>
        </div>
      </el-col>
    </el-row>

    <el-table
      v-loading="tableData4Loading"
      :data="tableData4.list"
      style="width: 100%"
      height="462"
    >
      <el-table-column prop="name" label="姓名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="clockInType"
        label="上班打卡方式"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-tooltip
            v-if="row.clockInType == 3"
            class="item"
            effect="dark"
            :content="row.fieldPersonnelRemark"
            placement="top"
          >
            <span v-if="row.clockInType == 1">地点打卡</span>
            <span v-if="row.clockInType == 2">Wifi打卡</span>
            <span v-if="row.clockInType == 3">外勤打卡</span>
          </el-tooltip>
          <div v-else>
            <span v-if="row.clockInType == 1">地点打卡</span>
            <span v-if="row.clockInType == 2">Wifi打卡</span>
            <span v-if="row.clockInType == 3">外勤打卡</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="clockInTime"
        label="上班打卡时间"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ parseTime(scope.row.clockInTime) }}
        </template>
      </el-table-column>

      <el-table-column
        label="上班打卡状态"
        align="center"
        prop="clockInStatus"
        width="300"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.clockInStatus == 1" type="success" size="small"
            >正常</el-tag
          >
          <el-tag v-if="row.clockInStatus == 2" type="warning" size="small"
            >迟到</el-tag
          >
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="endClockInType"
        label="下班打卡方式"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span v-if="row.endClockInType == 1">地点打卡</span>
          <span v-if="row.endClockInType == 2">Wifi打卡</span>
          <span v-if="row.endClockInType == 3">外勤打卡</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="endClockInType"
        label="下班打卡方式"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-tooltip
            v-if="row.endClockInType == 3"
            class="item"
            effect="dark"
            :content="row.endFieldPersonnelRemark"
            placement="top"
          >
            <span v-if="row.endClockInType == 1">地点打卡</span>
            <span v-if="row.endClockInType == 2">Wifi打卡</span>
            <span v-if="row.endClockInType == 3">外勤打卡</span>
          </el-tooltip>
          <div v-else>
            <span v-if="row.endClockInType == 1">地点打卡</span>
            <span v-if="row.endClockInType == 2">Wifi打卡</span>
            <span v-if="row.endClockInType == 3">外勤打卡</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="endClockInTime"
        label="下班打卡时间"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ parseTime(scope.row.endClockInTime) }}
        </template>
      </el-table-column>

      <el-table-column
        label="下班打卡状态"
        align="center"
        prop="endClockInStatus"
        width="300"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.endClockInStatus == 1" type="success" size="small"
            >正常</el-tag
          >
          <el-tag v-if="row.endClockInStatus == 2" type="warning" size="small"
            >早退</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="toolbar" style="padding: 10px">
      <pagination
        v-show="total4 > 0"
        :total="total4"
        :page.sync="filters.pageNum"
        :limit.sync="filters.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import PopupTreeInput from "@/components/PopupTreeInput";
import {
  getStatistics,
  getStatisticsList,
  getManagementList,
} from "@/api/Industry";
import axios from "axios";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: { PopupTreeInput },
  // 组件状态值
  data() {
    return {
      options: [],
      count: {},
      tableData4: {},
      tableData4Loading: false,
      companyId: this.$route.query.EId,
      platformId: this.$route.query.platformId,
      url: this.$route.query.url,
      filters: {
        type: "1",
        pageNum: 1,
        pageSize: 10,
        platformId: this.$route.query.platformId,
        companyId: this.$route.query.EId,
        managementId: "",
        deptId: "",
      },
      total4: 0,
      deptData: [],
      deptTreeProps: {
        label: "name",
        children: "children",
      },
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 查询
    handleFilter(val) {
      this.tableData4Loading = true;
      this.filters.pageNum = val;
      this.getList();
    },
    // 获取考勤组
    getManagementList() {
      getManagementList({
        companyId: this.companyId,
        platformId: this.platformId,
        pageNum: 1,
        pageSize: 999,
      }).then((res) => {
        if (res.code == 0) {
          this.options = res.data.list;
        }
      });
    },
    getType(val) {
      this.filters.type = val;
      this.getList();
    },
    // 获取组织机构
    findDeptTree: function() {
      axios({
        url: this.url + "/OA/treeList?companyId=" + this.companyId,
      }).then((res) => {
        if (res.data.code == 0) {
          //   this.deptOptions = res.data.data;
          this.deptData = this.getParentMenuTree(res.data.data);
        }
      });
    },
    // 树形组织机构添加全部
    getParentMenuTree: function(tableTreeDdata) {
      const parent = {
        deptId: "",
        name: "全部",
        children: tableTreeDdata,
      };
      return [parent];
    },
    deptTreeCurrentChangeHandles(data, node) {
      this.filters.deptId = data.deptId;
      this.filters.name = data.name;
    },

    // 获取统计 数据
    getCount() {
      getStatistics(this.filters).then((res) => {
        if (res.code == 200) {
          this.count = res.data;
        }
      });
    },

    // 获取人员列表
    getList() {
      this.tableData4Loading = true;
      getStatisticsList(this.filters).then((res) => {
        if (res.code == 200) {
          this.total4 = res.data.total;
          this.tableData4 = res.data;
          this.tableData4Loading = false;
        }
      });
    },
  },

  created() {},

  mounted() {
    this.findDeptTree();
    this.getList();
    this.getCount();
    this.getManagementList();
  },
};
</script>

<style scoped lang="less">
.line {
  cursor: pointer;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px 10px 0;
}
@media (max-width: 992px) {
  .el-col-lg-24-5 {
    width: 50%;
  }
}
@media (min-width: 992px) {
}
@media (min-width: 992px) {
  .el-col-lg-24-5 {
    width: 33.3%;
  }
}
@media (min-width: 1350px) {
  .el-col-lg-24-5 {
    width: 20%;
  }
}

.title {
  font-size: 18px;
  font-weight: bold;
  font-family: PingFang SC;
  margin-bottom: 20px;
}
.des {
  font-size: 15px;
  color: #606266;
  font-family: PingFang SC;
  margin-bottom: 10px;
}
.number {
  font-size: 21px;
  font-weight: normal;
}
.toolbar {
  margin-bottom: 8px;
}
</style>
